import { Badge, Image, ProgressBar, Button } from "@blend-ed/blendx-ui"
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n"
import { AppContext } from "@edx/frontend-platform/react"
import { useMutation as useReactMutation } from "@tanstack/react-query"
import { useContext } from "react"
import { markAttendance } from "../api/LearnerAttendance"
import placeholder from "../assets/images/placeholder.jpg"
import placeholderDark from "../assets/images/placeholder-dark.png"
import messages from "./messages"

const RecentActivityCard = ({ intl, image, title, type, progressPercentage, link, courseId }) => {

  const { authenticatedUser } = useContext(AppContext)

  const markAttendanceMutation = useReactMutation({
    mutationFn: (data) => markAttendance(data.userId, data.courseId),
    onSuccess: () => {
      window.location.href = link
    },
    onError: (error) => {
      window.location.href = link
    }
  });

  const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

  return (
    <div className="recent-activity-card">
      <Image
        src={image}
        alt={title}
        className="recent-activity-card__image"
        onError={(e) => {
          e.target.src = isDarkMode ? placeholderDark : placeholder;
        }}
      />
      <div className="recent-activity-card__body">
        <div className="recent-activity-card__head">
          <Badge variant="yellow" size="sm" className="recent-activity-card__badge">{type}</Badge>
          <div className="recent-activity-card__title text-truncate">{title}</div>
          <ProgressBar progress={progressPercentage} size="sm" type="inline" />
        </div>
        <Button
          size="xs"
          variant="outline-gray"
          iconBefore="play"
          iconType="fill"
          border
          className="recent-activity-card__button"
          onClick={() => {
            markAttendanceMutation.mutate({
              userId: authenticatedUser.id,
              courseId
            })
          }}
        >
          {intl.formatMessage(messages.resume)}
        </Button>
      </div>
    </div>
  );
}

RecentActivityCard.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(RecentActivityCard);